var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgGmaps = function SvgGmaps(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Shape1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "shapePath1",
    d: "M256.15,512 C248.45,512 241.25,508.2 236.95,502 L106.35,314.4 C78.15,280.6 62.65,237.4 62.65,192.6 C62.65,86.4 149.45,0 256.05,0 C362.65,0 449.35,86.4 449.35,192.6 C449.35,225.2 440.95,257.5 425.05,286.1 C424.45,287.6 423.65,289 422.75,290.4 C417.55,298.8 412.65,305.8 407.45,312.3 L275.45,501.9 C271.05,508.2 263.85,512 256.15,512 M241.954,300.6 L361.2,235.3 C300.63,-124.58 13.5886,262.054 241.954,300.6 Z",
    style: {
      stroke: "#323232",
      strokeOpacity: 1,
      strokeWidth: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeLinecap: "butt",
      fillRule: "evenodd",
      fill: "#6a6e7c",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "shapePath2",
    d: "M252.8,327.18 C193,327.18 124.908,252.1 124.908,192.6 C124.908,133 193,61.5643 252.8,61.5643 C312.6,61.5643 380.692,133.1 380.692,192.6 C380.692,252.1 312.6,327.18 252.8,327.18 M252.8,105.7 C204.6,105.7 165.5,144.7 165.5,192.6 C165.5,240.5 204.7,279.5 252.8,279.5 C301,279.5 340.1,240.5 340.1,192.6 C340.1,144.7 301,105.7 252.8,105.7 Z",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#6a6e7c",
      fillOpacity: 1
    }
  })));
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGmaps, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gmaps.fc8a2bd3.svg";
export { ForwardRef as ReactComponent };